import { render, staticRenderFns } from "./ReferenceSelector.vue?vue&type=template&id=1bd106af"
import script from "./ReferenceSelector.vue?vue&type=script&lang=js"
export * from "./ReferenceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports